// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeDisplayStatus {
  Unknown = "UNKNOWN",
  NotPaid = "NOT_PAID",
  BeforeValidity = "BEFORE_VALIDITY",
  Valid = "VALID",
  AfterValidity = "AFTER_VALIDITY",
  RefundedToCustomer = "REFUNDED_TO_CUSTOMER",
  RefundedToDistributor = "REFUNDED_TO_DISTRIBUTOR",
}
export default ChargeDisplayStatus;

export function chargeDisplayStatusToVariant(chargeDisplayStatus: ChargeDisplayStatus) {
  switch (chargeDisplayStatus) {
    case ChargeDisplayStatus.Unknown:
    case ChargeDisplayStatus.AfterValidity:
      return "gray";

    case ChargeDisplayStatus.NotPaid:
      return "danger";

    case ChargeDisplayStatus.Valid:
      return "success";

    case ChargeDisplayStatus.BeforeValidity:
      return "warning";

    case ChargeDisplayStatus.RefundedToCustomer:
    case ChargeDisplayStatus.RefundedToDistributor:
      return "secondary";
  }
}
